import { useMediaQuery } from '@material-ui/core'
import UploadIcon from '@material-ui/icons/BackupOutlined'
import { Button, IconButton } from 'opensolar-ui'
import { PaginationComp, useNotify, useTranslate } from 'react-admin'
import { useHistory } from 'react-router-dom'
import { handleCsvDownload } from 'resources/projects/util'

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginLeft: 10,
  },
}

const PaginationWithActions = ({ downloadUrl, downloadFilename, downloadCSV, ...props }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const history = useHistory()
  const showIconButton = useMediaQuery((theme) => theme.breakpoints.down('lg'))
  const handleClick = () => history.push('/csv_upload?model=' + props.uploadModel)
  const {
    downloadLabel,
    secondaryDownloadUrl,
    secondaryDownloadFilename,
    secondaryDownloadCSV,
    secondaryDownloadLabel,
    ...paginationProps
  } = props
  const primaryLabel = downloadLabel || translate('Download')
  return (
    <div style={styles.wrapper}>
      <div style={styles.buttonWrapper}>
        {downloadUrl && downloadFilename && (
          <Button
            style={{ margin: 8 }}
            onClick={(event) =>
              handleCsvDownload(
                downloadUrl,
                notify,
                props.filterValues,
                downloadFilename,
                { page: props.page, perPage: props.perPage },
                downloadCSV
              )
            }
            className={'MuiButton-textPrimary'}
          >
            <span>{primaryLabel}</span>
          </Button>
        )}

        {secondaryDownloadUrl && secondaryDownloadFilename && (
          <Button
            style={{ margin: 8 }}
            onClick={() =>
              handleCsvDownload(
                secondaryDownloadUrl,
                notify,
                props.filterValues,
                secondaryDownloadFilename,
                { page: props.page, perPage: props.perPage },
                secondaryDownloadCSV
              )
            }
            className={'MuiButton-textPrimary'}
          >
            <span>{secondaryDownloadLabel || translate('Download')}</span>
          </Button>
        )}

        {props.uploadModel &&
          (showIconButton ? (
            <IconButton style={{ borderRadius: 2 }} onClick={handleClick}>
              <UploadIcon />
            </IconButton>
          ) : (
            <Button onClick={handleClick}>
              <span>{translate('Upload & Import CSV')}</span>
            </Button>
          ))}
      </div>
      <PaginationComp {...paginationProps} />
    </div>
  )
}

export default PaginationWithActions
